import { Typography } from "@mindlercare/ui-web";
import { type ReactNode } from "react";
import { styled } from "styled-components";

export const ModalContentColumn = styled.div<{ leftPadding?: number }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  scrollbar-gutter: stable;
  flex: 1;
  min-width: 0;
  padding-left: ${({ leftPadding }) =>
    leftPadding ? `${leftPadding}px` : "0px"};
`;

export const ListItemSubtitle = ({ children }: { children: ReactNode }) => (
  <Typography variant="body-small" color="GRAY" insensitive>
    {children}
  </Typography>
);

export const List = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  flex-basis: auto;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-grow: 1;
  width: 100%;
  overflow: hidden;
`;

export const CenteredContainer = styled.div`
  width: fit-content;
  margin: auto;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: auto;
  align-items: center;
  padding-top: ${({ theme }) => theme.PADDING.LG};
  gap: ${({ theme }) => theme.PADDING.MD};
`;
